module.exports = __webpack_public_path__ + "img/success.b1156442.png";